<template>
  <div class="appraise-view">
    <Form ref="newForm"
      v-if="formLoaded"
      :model="paper"
      label-position="left"
      :label-width="160">
      <div class="print-area">
        <v-print :doPrint.sync="print">
          <table class="form-table">
            <tbody>
              <tr>
                <th colspan="4" class="table-header">{{ this.paper.title }}</th>
              </tr>
              <tr class="section-header">
                <td colspan="4">
                  机构名称：{{ record.guarantorName }}
                </td>
              </tr>
              <section v-for="(section,sectionId) in this.paper.sections" :key="sectionId">
                <section  v-if="section.isSelfAppraise">
                  <tr class="section-header" v-if="section.isAttachment">
                    <td colspan="4">
                      {{ section.title }}
                    </td>
                  </tr>
                  <tr class="section-header" v-else-if="section.showTitle">
                    <td colspan="4">
                      {{ section.title }} {{ section.totalScore ? `（总分值：${section.totalScore}）` : ''}}
                      <div class="section-score">{{ section.calculatedScore }}</div>
                    </td>
                  </tr>
                  <tr class="table-row"
                    v-for="(question,questionId) in section.questions" :key="questionId">
                    <td width="50%">
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[1].indexOf(question.type)>=0">
                        {{ question.value }}
                        <span v-if="question.needExtInfo&&question.optionValue!==null&&question.optionValue!==undefined&&question.options&&(question.options instanceof Array)&&question.options[question.optionValue]">
                          （{{ question.options[question.optionValue].label }}）
                        </span>
                        <div v-if="question.needExtInput&&question.options&&(question.options instanceof Array)">
                          <span class="options-static" v-for="(opt,optIdx) in question.options" :key="optIdx">
                            {{ opt.label }}: {{opt.value}}
                          </span>
                        </div>
                        <div v-if="question.needExtInfo&&((question.adjustedValue!==null&&question.adjustedValue!==undefined)||(question.adjustedOptionValue!==null&&question.adjustedOptionValue!==undefined))"
                          class="font-red">
                          <b>修订值：{{ question.adjustedValue }} ({{ question.options[question.adjustedOptionValue].label }})</b>
                        </div>
                        <div v-else-if="question.needExtInput&&(question.adjustedValue!==null&&question.adjustedValue!==undefined)&&question.options&&(question.options instanceof Array)"
                          class="font-red">
                          <b>修订值：{{ question.adjustedValue }}</b><br/>
                          <span class="options-static" v-for="(opt,optIdx) in question.options" :key="optIdx">
                            {{ opt.label }}: {{opt.adjustedValue}}
                          </span>
                        </div>
                        <div v-else-if="!question.needExtInfo&&!question.needExtInput&&question.adjustedValue!==null&&question.adjustedValue!==undefined"
                          class="font-red">
                          <b>修订值：{{ question.adjustedValue }}</b>
                        </div>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[0].indexOf(question.type)>=0">
                        {{ question.value }}
                        <span v-if="question.needExtInfo&&question.optionValue!==null&&question.optionValue!==undefined&&question.options&&(question.options instanceof Array)&&question.options[question.optionValue]">
                          （{{ question.options[question.optionValue].label }}）
                        </span>
                        <div v-if="question.needExtInput&&question.options&&(question.options instanceof Array)">
                          <span class="options-static" v-for="(opt,optIdx) in question.options" :key="optIdx">
                            {{ opt.label }}: {{opt.value}}
                          </span>
                        </div>
                        <div v-if="question.needExtInfo&&((question.adjustedValue!==null&&question.adjustedValue!==undefined)||(question.adjustedOptionValue!==null&&question.adjustedOptionValue!==undefined))"
                          class="font-red">
                          <b>修订值：{{ question.adjustedValue }} ({{ question.options[question.adjustedOptionValue].label }})</b>
                        </div>
                        <div v-else-if="question.needExtInput&&(question.adjustedValue!==null&&question.adjustedValue!==undefined)&&question.options&&(question.options instanceof Array)"
                          class="font-red">
                          <b>修订值：{{ question.adjustedValue }}</b><br/>
                          <span class="options-static" v-for="(opt,optIdx) in question.options" :key="optIdx">
                            {{ opt.label }}: {{opt.adjustedValue}}
                          </span>
                        </div>
                        <div v-else-if="!question.needExtInfo&&!question.needExtInput&&question.adjustedValue!==null&&question.adjustedValue!==undefined"
                          class="font-red">
                          <b>修订值：{{ question.adjustedValue }}</b>
                        </div>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[2].indexOf(question.type)>=0">
                        <div>{{ question.value ? '是' : '否' }}</div>
                        <FormItem label="" :prop="`sections[${sectionId}].questions[${questionId}].detail`"
                          v-if="question.needDetail&&question.value">
                          <div style="word-break: break-all;white-space: pre-wrap;">{{ question.detail }}</div>
                        </FormItem>
                        <div v-if="question.adjustedValue!==null&&question.adjustedValue!==undefined" class="font-red">
                          <div><b>修订值：{{ question.adjustedValue ? '是' : '否' }}</b></div>
                          <div v-if="question.needDetail&&question.adjustedDetail" style="word-break: break-all;white-space: pre-wrap;">{{ question.adjustedDetail }}</div>
                        </div>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[3].indexOf(question.type)>=0">
                        <div>{{ question.value ? '是' : '否' }}</div>
                        <FormItem label="" :prop="`sections[${sectionId}].questions[${questionId}].detail`"
                          v-if="question.needDetail&&question.value">
                          <div style="word-break: break-all;white-space: pre-wrap;">{{ question.detail }}</div>
                        </FormItem>
                        <div v-if="question.adjustedValue!==null&&question.adjustedValue!==undefined" class="font-red">
                          <div><b>修订值：{{ question.adjustedValue ? '是' : '否' }}</b></div>
                          <div v-if="question.needDetail&&question.adjustedDetail" style="word-break: break-all;white-space: pre-wrap;">{{ question.adjustedDetail }}</div>
                        </div>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[6].indexOf(question.type)>=0">
                        <div v-if="question.options&&(question.options instanceof Array)&&question.options[question.value]">{{ question.options[question.value].label }}</div>
                        <div v-if="question.options&&(question.options instanceof Array)&&question.options[question.adjustedValue]" class="font-red"><b>修订值：{{ question.options[question.adjustedValue].label }}</b></div>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[4].indexOf(question.type)>=0">
                        <div class="question-list-type">
                          <div class="question-list-item-list" v-if="question.value && (question.value instanceof Array) && question.value.length">
                            <div class="question-list-item"
                              v-for="(listItem, listItemIdx) in question.value"
                              :key="listItemIdx">
                              <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].value[${listItemIdx}].value`">
                                <div style="word-break: break-all;white-space: pre-wrap;">{{ listItem.value }}</div>
                              </FormItem>
                            </div>
                          </div>
                          <div v-else>无</div>
                          <div v-if="question.adjustedValue && (question.adjustedValue instanceof Array)" class="font-red"><b>修订值：</b></div>
                          <div class="question-list-item-list adjust" v-if="question.adjustedValue && (question.adjustedValue instanceof Array)">
                            <div class="question-list-item"
                              v-for="(listItem, listItemIdx) in question.adjustedValue"
                              :key="listItemIdx">
                              <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].adjustedValue[${listItemIdx}].value`">
                                <div style="word-break: break-all;white-space: pre-wrap;">{{ listItem.value }}</div>
                              </FormItem>
                            </div>
                          </div>
                        </div>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[7].indexOf(question.type)>=0">
                        <div class="question-list-type">
                          <div class="question-list-item-list" v-if="question.value && (question.value instanceof Array) && question.value.length">
                            <div class="question-list-item"
                              v-for="(listItem, listItemIdx) in question.value"
                              :key="listItemIdx">
                              <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].value[${listItemIdx}].value`">
                                <div v-if="question.options&&(question.options instanceof Array)&&question.options.find(o=>o.value===listItem.value)">{{ question.options.find(o=>o.value===listItem.value).label }}</div>
                                <div style="word-break: break-all;white-space: pre-wrap;">{{ listItem.detail }}</div>
                              </FormItem>
                            </div>
                          </div>
                          <div v-else>无</div>
                          <div v-if="question.adjustedValue && (question.adjustedValue instanceof Array)" class="font-red"><b>修订值：</b></div>
                          <div class="question-list-item-list adjust" v-if="question.adjustedValue && (question.adjustedValue instanceof Array)">
                            <div class="question-list-item"
                              v-for="(listItem, listItemIdx) in question.adjustedValue"
                              :key="listItemIdx">
                              <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].adjustedValue[${listItemIdx}].value`">
                                <div v-if="question.options&&(question.options instanceof Array)&&question.options.find(o=>o.value===listItem.value)">{{ question.options.find(o=>o.value===listItem.value).label }}</div>
                                <div style="word-break: break-all;white-space: pre-wrap;">{{ listItem.detail }}</div>
                              </FormItem>
                            </div>
                          </div>
                        </div>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].url`" class="form-item"
                        v-if="[5].indexOf(question.type)>=0">
                        <div class="attachments">
                          <div class="attachment-thumb"
                            @click="previewImgUrl=item;showPreview=true"
                            :key="index"
                            v-for="(item,index) in question.url">
                            <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                            <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix.toUpperCase()}}</span>
                            <div class="attachment-thumb-cover">
                              <Icon type="ios-eye-outline" @click.stop="previewImgUrl=item;showPreview=true"></Icon>
                            </div>
                          </div>
                        </div>
                      </FormItem>
                    </td>
                    <td width="50%" class="item-extra-td">
                      <div class="description">
                        {{ question.description }}
                      </div>
                      <div class="score">
                        <div v-if="!section.isAttachment">自评得分：{{ question.calculatedScore }}</div>
                        <div v-if="!section.isAttachment&&question.adjustedScore!==undefined&&question.adjustedScore!==null" class="font-red"><b>修订得分：{{ question.adjustedScore }}</b></div>
                      </div>
                    </td>
                  </tr>
                </section>
                <section v-if="!section.isSelfAppraise&&isAdmin">
                  <tr class="section-header" if="section.showTitle">
                    <td colspan="4">
                      {{ section.title }} {{ section.totalScore ? `（总分值：${section.totalScore}）` : ''}}
                      <div class="section-score">{{ section.calculatedScore }}</div>
                    </td>
                  </tr>
                  <tr class="table-row"
                    v-for="(question,questionId) in section.questions" :key="questionId">
                    <td width="50%">
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[1].indexOf(question.type)>=0">
                        {{ question.value }}
                        <span v-if="question.needExtInfo&&question.optionValue!==null&&question.optionValue!==undefined&&question.options&&(question.options instanceof Array)&&question.options[question.optionValue]">
                          （{{ question.options[question.optionValue].label }}）
                        </span>
                        <div v-if="question.needExtInput&&question.options&&(question.options instanceof Array)">
                          <span class="options-static" v-for="(opt,optIdx) in question.options" :key="optIdx">
                            {{ opt.label }}: {{opt.value}}
                          </span>
                        </div>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[0].indexOf(question.type)>=0">
                        {{ question.value }}
                        <span v-if="question.needExtInfo&&question.optionValue!==null&&question.optionValue!==undefined&&question.options&&(question.options instanceof Array)&&question.options[question.optionValue]">
                          （{{ question.options[question.optionValue].label }}）
                        </span>
                        <div v-if="question.needExtInput&&question.options&&(question.options instanceof Array)">
                          <span class="options-static" v-for="(opt,optIdx) in question.options" :key="optIdx">
                            {{ opt.label }}: {{opt.value}}
                          </span>
                        </div>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[2].indexOf(question.type)>=0">
                        <div>{{ question.value ? '是' : '否' }}</div>
                        <FormItem label="" :prop="`sections[${sectionId}].questions[${questionId}].detail`" 
                          v-if="question.needDetail&&question.value">
                          <div style="word-break: break-all;white-space: pre-wrap;">{{ question.detail }}</div>
                        </FormItem>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[3].indexOf(question.type)>=0">
                        <div>{{ question.value ? '是' : '否' }}</div>
                        <FormItem label="" :prop="`sections[${sectionId}].questions[${questionId}].detail`"
                          v-if="question.needDetail&&question.value">
                          <div style="word-break: break-all;white-space: pre-wrap;">{{ question.detail }}</div>
                        </FormItem>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[6].indexOf(question.type)>=0">
                        <div v-if="question.options&&(question.options instanceof Array)&&question.options[question.value]">{{ question.options[question.value].label }}</div>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[4].indexOf(question.type)>=0">
                        <div class="question-list-type">
                          <div class="question-list-item-list" v-if="question.value && (question.value instanceof Array) && question.value.length">
                            <div class="question-list-item"
                              v-for="(listItem, listItemIdx) in question.value"
                              :key="listItemIdx">
                              <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].value[${listItemIdx}].value`">
                                <div style="word-break: break-all;white-space: pre-wrap;">{{ listItem.value }}</div>
                              </FormItem>
                            </div>
                          </div>
                          <div v-else>无</div>
                        </div>
                      </FormItem>
                      <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                        v-if="[7].indexOf(question.type)>=0">
                        <div class="question-list-type">
                          <div class="question-list-item-list" v-if="question.value && (question.value instanceof Array) && question.value.length">
                            <div class="question-list-item"
                              v-for="(listItem, listItemIdx) in question.value"
                              :key="listItemIdx">
                              <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].value[${listItemIdx}].value`">
                                <div v-if="question.options&&(question.options instanceof Array)&&question.options.find(o=>o.value===listItem.value)">{{ question.options.find(o=>o.value===listItem.value).label }}</div>
                                <div style="word-break: break-all;white-space: pre-wrap;">{{ listItem.detail }}</div>
                              </FormItem>
                            </div>
                          </div>
                          <div v-else>无</div>
                        </div>
                      </FormItem>
                    </td>
                    <td width="50%" class="item-extra-td">
                      <div class="description">
                        {{ question.description }}
                      </div>
                      <div class="score">
                        <div v-if="!section.isAttachment">本项得分：{{ question.calculatedScore }}</div>
                      </div>
                    </td>
                  </tr>
                </section>
              </section>
              <tr class="section-header">
                <td colspan="4">
                  自评总分： {{ Math.round(record.calculatedScore*100)/100}}
                </td>
              </tr>
              <tr class="section-header">
                <td colspan="4">
                  审核总分： {{ Math.round(record.adjustedScore*100)/100}}
                </td>
              </tr>
              <tr class="section-header">
                <td colspan="4">
                  最终评级： {{ record.grade }}
                </td>
              </tr>
              <tr class="section-header" v-if="record.remark">
                <td colspan="4">
                  备注： {{ record.remark }}
                </td>
              </tr>
            </tbody>
          </table>
        </v-print>
      </div>
    </Form>
    <Row :gutter="32" v-if="formLoaded">
      <i-col span="8">
        <i-button @click="print=true">打印</i-button>
      </i-col>
    </Row>
    <div class="full" v-if="!formLoaded">
      <Spin fix>加载中...</Spin>
    </div>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'">查看</a>
    </Modal>
  </div>
</template>

<script>
import Api from '../../api/Api.js'
import vPrint from 'syl-vue-printer'
export default {
  components: {
    vPrint
  },
  data () {
    return {
      loading: false,
      paper: {},
      formLoaded: false,
      isVeto: false, // 一票否决
      previewImgUrl: null,
      showPreview: false,
      record: null,
      print: false
    }
  },
  computed: {
    isAdmin () {
      return this.checkRolePermitted(['总监管人','管理员'])
    }
  },
  mounted () {
    this.initForm()
  },
  methods: {
    async getAppraisalRecordData () {
      if (this.$route.params.recordId) {
        this.formLoaded = false
        let record = await Api.Appraisal.getAppraisalRecord(this.$route.params.recordId)
          .catch(err => {
            this.$Notice.error({
              title: '获取记录失败!',
              desc: err.message
            })
            return Promise.reject('获取记录失败!')
          })
        // console.log(record)
        this.record = record
        if (record.rawJson) {
          // 处理草稿数据
          let paper = JSON.parse(record.rawJson)
          if (!paper.sections) {
            paper.sections = []
          }
          let attachSection = paper.sections.find(o => o.isAttachment)
          if (attachSection) {
            if (!attachSection.questions) {
              attachSection.questions = []
            }
            attachSection.questions.forEach((q) => {
              if (q.ossKeys) {
                q.filePath = ''
                q.url = []
                q.ossKeys.forEach((o) => {
                  this.$nextTick(() => {
                    let key = o.indexOf('oss:') === 0 ? o.substr(4) : o
                    this.procOssKey(key).then(url => {
                      url.status = 'finished'
                      q.url.push(url)
                    })
                  })
                })
                q.filePath = q.ossKeys.join(',')
              }
            })
          }
          this.paper = paper
          console.log(this.paper)
          this.formLoaded = true
          return Promise.resolve()
        } else {
          this.$Notice.error({
            title: '获取记录失败!',
            desc: '原始数据错误'
          })
          return Promise.reject('获取记录失败!')
        }
      }
    },
    checkRolePermitted (roles) {
      // if (this.$store.getters.userInfo.type === 127) {
      //   return true
      // }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    async initForm () {
      await this.getAppraisalRecordData()
    },
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    arrayValidator (rule, value, callback) {
      if (!value || !(value instanceof Array) || !value.length) {
        callback(new Error('没有元素'))
      } else {
        callback()
      }
    },
    getFormats (fmtStr) {
      if (!fmtStr) {
        return ['pdf', 'jpg', 'jpeg', 'png']
      }
      let arr = fmtStr.split(',')
      let result = arr.map((a) => {
        return a.trim()
      })
      return result
    },
    previewUploaded (file) {
      let key = file.name.indexOf('oss:') === 0 ? file.name.substr(4) : file.name
      this.procOssKey(key).then((obj) => {
        console.log(obj)
        this.previewImgUrl = obj.url
        this.showPreview = true
      })
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve) => {
        let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
        if (surfix.indexOf('?')) {
          surfix = surfix.substring(0, surfix.indexOf('?'))
        }
        let type = 'image'
        switch (surfix) {
          case 'jpg':
            type = 'image'
            break
          case 'jpeg':
            type = 'image'
            break
          case 'png':
            type = 'image'
            break
          case 'gif':
            type = 'image'
            break
          case 'pdf':
            type = 'file'
            break
          case 'doc':
            type = 'file'
            break
          case 'docx':
            type = 'file'
            break
          case 'xls':
            type = 'file'
            break
          case 'xlsx':
            type = 'file'
            break
          case 'ppt':
            type = 'file'
            break
          case 'pptx':
            type = 'file'
            break
          default:
            type = 'file'
            break
        }
        resolve({
          name: k,
          url,
          type,
          surfix
        })
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    getSuffix (filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos !== -1) {
        suffix = filename.substring(pos)
      }
      return suffix
    },
    draft () {
      this.loading = true
      this.$Spin.show()
      this.calculate()
      this.$nextTick(() => {
        Api.Appraisal.submitAppraisalPaper({
          id: this.record.tid,
          isDraft: true,
          calculatedScore: this.paper.calculatedScore,
          rawJson: JSON.stringify(this.paper)
        }).then(() => {
          this.$Message.success('保存成功!')
          this.loading = false
          this.$Spin.hide()
          this.$router.back()
        })
        .catch(err => {
          console.log('err', err)
          this.$Message.error('提交失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.attachments {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  flex-wrap: wrap;
}
.attachment-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #efefef;
  width: 100px;
  height: 100px;
  margin-right: 4px;
  transition: all .2s ease-in-out;
  cursor: pointer;
  padding: 3px;
  border: 1px solid #d2d2d2;
  position: relative;
  &:hover {
    border: 1px solid rgb(65,157,253);
    background-color: #fff;
  }
  overflow: hidden;
  img {
    width: 100%;
  }
  .attachment-thumb-cover{
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    transition: all .3s linear;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  &:hover .attachment-thumb-cover{
    opacity: 1;
  }
  .attachment-thumb-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 5px;
  }
}
.question-list-item-list {
  list-style-type: none;
  counter-reset: css-counter 0;
  .question-list-item {
    counter-increment: css-counter 1;
    &::before {
      content: counter(css-counter) ". ";
    }
  }
  .question-list-item:not(:last-child) {
    border-bottom: 1px solid #ccc;
  }
}

</style>